<template>
  <div id="Banner">
    <Carousel v-model="bannerIndex" loop arrow="always">
      <CarouselItem v-for="(banner, index) in banners" :key="index">
        <img class="carousel-item" :src="banner['image']"/>
        <div v-if="banner['title']" style="margin-top: -36px;float: bottom;width: 100%;height: 36px;line-height: 36px;padding-left: 10px;color: #464c5b;font-size: 16px;">{{banner['title']}}</div>
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
import {getBannerList} from "@/request/web/banner";
export default {
  name: "Banner",
  // 注册组件
  components: {},
  // 属性
  props: {},
  // 页面数据
  data() {
    return {
      bannerIndex: 0,
      banners: []
    }
  },
  created() {
    this.onGetBannerList();
  },
  methods: {
    onGetBannerList() {
      getBannerList().then(res=> {
        this.banners = res.data.data['list']
      })
    }
  }
}
</script>

<style scoped>
.carousel-item {
  width: 100%;
  height: 360px;
  background-color: #464c5b;
  object-fit: cover;
}
</style>
